export const META_THEME_COLORS = {
  light: '#ffffff',
  dark: '#09090b',
};
